module.exports = __webpack_public_path__ + "img/box.70a4432a.png";